import React from "react";
import { CHECK_OUTLINE } from "../../assets/icons";
import { APPLESTORE, PLAYSTORE, QR_CODE, GETAPP } from "../../assets/images";

export default function GetApp() {
  return (
    <div className="flex flex-col lg:flex-row py-12 container m-auto justify-between">
      <div className="lg:w-2/3 w-full">
        <div className="my-3">
          <span className="md:text-4xl text-2xl font-medium text-primary">
            Get the worldOtutors app
          </span>
        </div>
        <div className="my-10">
          <div className="flex gap-5 my-3">
            <span>
              <img src={CHECK_OUTLINE} alt="check icon" />
            </span>
            <span>Find the best tutors</span>
          </div>
          <div className="flex gap-5">
            <span>
              <img src={CHECK_OUTLINE} alt="check icon" />
            </span>
            <span>Become a great tutor</span>
          </div>
        </div>
        <div className="flex flex-row bg-white rounded w-fit my-10">
          <div className="flex">
            <img src={QR_CODE} alt="QR code" className="object-cover" />
          </div>
          <div className="flex flex-col justify-evenly">
            <span className="md:text-xl text-lg font-medium flex-nowrap mx-2">
              Simple way to download the Worldotutors app
            </span>
            <span className="md:text-lg text-base font-normal mx-2">
              Scan the QR code and download now
            </span>
          </div>
        </div>
        <div className="flex items-center">
          <span>
            <img src={APPLESTORE} alt="Apple-store" className="mr-5" />
          </span>
          <span>
            <img src={PLAYSTORE} alt="Play-store" className="mr-5" />
          </span>
        </div>
      </div>
      <div className="pt-12 lg:pt-0 flex justify-center">
        <img src={GETAPP} alt="WOT mobile" />
      </div>
    </div>
  );
}
